import { type FC } from 'react';
import { useTheme } from 'styled-components';

import { FilledWarningIcon, IconWrapper, OutlineWarningIcon } from './styled.ts';

export const HoverableWarningIcon: FC = () => {
  const { colors } = useTheme();

  return (
    <IconWrapper>
      <OutlineWarningIcon size={16} color={colors.critical100} />
      <FilledWarningIcon size={16} color={colors.critical100} filled />
    </IconWrapper>
  );
};
